import http from '@/plugins/axios_plugin';

class ServiceRecebimentos {

  listar () {
    return http.get('/api/recebimentos/listar');
  }

  salvar (recebimento) {
    return http.post('/api/recebimentos/salvar', recebimento);
  }

  editar (recebimento_id) {
    return http.get('/api/recebimentos/' + recebimento_id + '/editar');
  }

  atualizar (recebimento_id, recebimento) {
    return http.post('/api/recebimentos/' + recebimento_id + '/atualizar', recebimento);
  }

  excluir (recebimento_id) {
    return http.post('/api/recebimentos/' + recebimento_id + '/excluir');
  }
}

export default new ServiceRecebimentos();